<template>
  <footer>
    <p>
      Fait avec <i class="icon icon-heart"></i> par
      <a
        class="link--invisible"
        href="http://www.codelutin.com"
        title="Code Lutin"
      >
        <i class="icon icon-lutin"></i>
      </a>

      <span title="Copyright" class="copyright">©2010-2020</span>
    </p>
    <p>
      <SimpleLink
        href="http://www.chorem.org/projects/bow"
        class="link"
      >bow</SimpleLink>

      <SimpleLink
        href="http://www.gnu.org/licenses/agpl.html"
        class="link"
      >License</SimpleLink>


      <SimpleLink
        href="http://www.codelutin.com"
        class="link"
      >Code Lutin</SimpleLink>

      <SimpleLink
        href="http://www.chorem.org/projects/bow/issues"
        class="link"
      >Bug report</SimpleLink>

      <SimpleLink
        href="http://list.chorem.org/cgi-bin/mailman/listinfo/bow-users"
        class="link"
      >Support</SimpleLink>
    </p>
  </footer>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import SimpleLink from '@/components/common/SimpleLink.vue'

@Component({
  name: 'Footer',
  components: { SimpleLink }
})
class Footer extends Vue {
}

export default Footer
</script>

<style scoped lang="less">
footer {
  height: var(--footer-height);

  padding: var(--margin--small);
  margin-top: calc(-1 * var(--footer-height));

  text-align: center;
  color: var(--color-footer-text);

  p {
    margin-top: var(--margin--small);
  }

  .link {
    margin-left: 10px;
    margin-right: 10px;
  }

  .icon {
    margin-left: var(--margin--tiny);
    margin-right: var(--margin--tiny);
  }
  .icon-lutin {
    font-size: 140%;
  }
  .copyright {
    margin-left: var(--margin--medium);
  }
}

.link--invisible:not(:hover) {
  color: var(--color-footer-text);
}
</style>
